import React from 'react';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Cookie Szabályzat</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Mi a cookie?</h2>
            <p>
              A cookie (süti) egy kis szöveges fájl, amelyet a weboldal a látogató számítógépére vagy 
              mobil eszközére helyez el. A cookie-k segítik a weboldal működését és javítják a felhasználói élményt.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookie-k típusai</h2>
            
            <div className="space-y-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-blue-900 mb-2">Szükséges cookie-k</h3>
                <p className="text-blue-800">
                  Ezek a weboldal alapvető működéséhez szükségesek. Nem kapcsolhatók ki, 
                  mert nélkülük a weboldal nem működne megfelelően.
                </p>
              </div>

              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-green-900 mb-2">Funkcionális cookie-k</h3>
                <p className="text-green-800">
                  Ezek javítják a weboldal funkcionalitását és személyre szabják a felhasználói élményt. 
                  Például nyelvbeállítások megjegyzése.
                </p>
              </div>

              <div className="bg-yellow-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold text-yellow-900 mb-2">Analitikai cookie-k</h3>
                <p className="text-yellow-800">
                  Segítenek megérteni, hogyan használják a látogatók a weboldalt. 
                  Anonimizált adatokat gyűjtenek a weboldal fejlesztéséhez.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Weboldalunkon használt cookie-k</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Cookie neve</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Célja</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Tartósság</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="px-4 py-3 text-sm text-gray-700">cookiesAccepted</td>
                    <td className="px-4 py-3 text-sm text-gray-700">Cookie hozzájárulás tárolása</td>
                    <td className="px-4 py-3 text-sm text-gray-700">1 év</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-sm text-gray-700">sessionId</td>
                    <td className="px-4 py-3 text-sm text-gray-700">Munkamenet azonosítása</td>
                    <td className="px-4 py-3 text-sm text-gray-700">Munkamenet végéig</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookie-k kezelése</h2>
            <p>Cookie-kat több módon is kezelhet:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Böngésző beállítások:</strong> A legtöbb böngészőben ki/be kapcsolhatja a cookie-kat</li>
              <li><strong>Cookie banner:</strong> Weboldalunkon megjelenő banner-en elfogadhatja vagy elutasíthatja</li>
              <li><strong>Manuális törlés:</strong> Böngészője beállításaiban törölheti a cookie-kat</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Harmadik felek cookie-k</h2>
            <p>
              Weboldalunkon harmadik felek (pl. Google Analytics, Facebook) cookie-kat is használhatnak. 
              Ezek kezeléséről a megfelelő szolgáltatók adatvédelmi szabályzataiban olvashat.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookie-k hatása</h2>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="mb-2"><strong>Cookie-k kikapcsolása esetén:</strong></p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Egyes funkciók nem működnek megfelelően</li>
                <li>Beállítások nem maradnak meg</li>
                <li>Felhasználói élmény romlhat</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Jogai</h2>
            <p>
              Cookie-kkal kapcsolatos kérdéseivel forduljon hozzánk az xlbutorbolt@gmail.com e-mail címen. 
              További információkat az Adatvédelmi Nyilatkozatunkban talál.
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Utolsó módosítás:</strong> 2024. december
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
